import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-info-button',
    templateUrl: './info-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoButtonComponent {
  @Input() labelName: string = '';
  @Input() url: string = '';
  @Input() placement: string = 'top';
  infoButtonStyle: InfoButtonStyle = InfoButtonStyle.Help;
  constructor() {
  }

  /**
   * True if set to Help or Unset
   * This is the default appearance for Tooltip/Info Helpers
   */
  public IsHelpStyle() {
    return !this.infoButtonStyle || this.infoButtonStyle == InfoButtonStyle.Help;
  }
  /**
   * True if set to Alert
   * if more styles are introduced than this can verify with checking type, otherwise not being Help/Default is enough
   */
  public IsAlertStyle() {
    return !this.infoButtonStyle || this.infoButtonStyle == InfoButtonStyle.Alert;
  }
  /**
   * True if set to Help or Unset
   * This is the default appearance for Tooltip/Info Helpers
   */
  public IsCloseableWrapperInfoStyle() {
    return !this.infoButtonStyle || this.infoButtonStyle == InfoButtonStyle.HelpCloseable;
  }
}

@Component({
    selector: 'app-danger-button',
    templateUrl: './info-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DangerInfoButtonComponent extends InfoButtonComponent {
  constructor() {
    super();
    this.infoButtonStyle = InfoButtonStyle.Alert;
  }
}

@Component({
    selector: 'app-closeable-info-button',
    templateUrl: './info-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloseableInfoButtonComponent extends InfoButtonComponent {
  constructor() {
    super();
    this.infoButtonStyle = InfoButtonStyle.HelpCloseable;
  }
}

export enum InfoButtonStyle {
  Help = 1,
  Alert = 2,
  HelpCloseable = 3,
}